module.exports = __webpack_public_path__ + "static/img/ad1.f7e2ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ad1.jpg
// module id = t/lH
// module chunks = 1